import identity from "lodash/fp/identity";

class TravelRequestPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    return identity(data);
  }
}

export default TravelRequestPageTransform;



// WEBPACK FOOTER //
// ./src/pages/travelRequest/travelRequest.transforms.js